import React from 'react';
import { Link } from 'react-router-dom';
import { Paper, MenuList, MenuItem, ListItemIcon, ListItemText } from '@mui/material';

import AddchartIcon from '@mui/icons-material/Addchart';
import SettingsIcon from '@mui/icons-material/Settings';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

export const MenuListCustom = ({ logout }) => {
    const origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;

    return (
        <Paper sx={{ width: 200, maxWidth: '100%' }} elevation={0}>
            <MenuList>
                <Link to="/dashboard" style={{ textDecoration: 'none', color: 'white' }}>
                    <MenuItem>
                        <ListItemIcon>
                            <AddchartIcon fontSize='small' />
                        </ListItemIcon>
                        <ListItemText>Dashboard</ListItemText>
                    </MenuItem>
                </Link>
                <Link to="/my-account" style={{ textDecoration: 'none', color: 'white' }}>
                    <MenuItem>
                        <ListItemIcon>
                            <SettingsIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Settings</ListItemText>
                    </MenuItem>
                </Link>
                <MenuItem onClick={() =>
                    logout({
                        logoutParams: {
                            returnTo: origin,
                        },
                    })
                }>
                    <ListItemIcon>
                        <PowerSettingsNewIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Log out</ListItemText>
                </MenuItem>
            </MenuList>
        </Paper>
    )
}